import { Component, input } from '@angular/core';
import { DataResult, ICRUDOptions } from '@phx-erp/shared';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { ItemSalesTaxCategory, ItemSalesTaxCategorySearchInput, TaxDirection } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { AppInfoService } from '../../../../../shared/services/app-info.service';
import { ItemSalesTaxCategoryService } from '../../services/item-sales-tax-category.service';

@Component({
  selector: 'app-item-sales-tax-category-drop-down',
  template: '',
  providers: [ItemSalesTaxCategoryService],
  standalone: true
})
export class ItemSalesTaxCategoryDropDownComponent extends GenericBaseModelDropDown<ItemSalesTaxCategory> {

  readonly direction = input<TaxDirection | undefined>(undefined);

  constructor(
    private service: ItemSalesTaxCategoryService,
    private appInfo: AppInfoService,
    public i18n: I18nService
  ) {
    super(service, "ItemSalesTaxCategory");
  }

  override executeSearch(searchInput: ItemSalesTaxCategorySearchInput, options?: ICRUDOptions): Promise<DataResult<any>> {

    const direction = this.direction() ?? (this.props?.attributes?.direction as TaxDirection | undefined);

    if (direction)
      searchInput.direction = direction;
    return super.executeSearch(searchInput, options);

  }
}
